import { render } from "./BloodGlucose.vue?vue&type=template&id=6c544cb0&scoped=true"
import script from "./BloodGlucose.vue?vue&type=script&lang=js"
export * from "./BloodGlucose.vue?vue&type=script&lang=js"

import "./BloodGlucose.vue?vue&type=style&index=0&id=6c544cb0&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c544cb0"]])

export default __exports__